import React, { useEffect, useState } from 'react';
import { IChatBotData, IChatHistoryData } from '../../redux/gemGPT/gemGPTslice';

export enum ChatBotSender {
  BOT = 'bot',
  USER = 'user',
}
export const handleCopy = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error('Error copying text: ', error);
  }
};

export const simulateApiCall = (response: any, delay = 2000) =>
  new Promise<string>((resolve) => {
    setTimeout(() => resolve(response), delay);
  });

export const randomResponse = () => {
  const randomResponseList = [
    'Hello, how can I help you today?',
    'I am here to assist you. How can I help you?',
    'What can I do for you today?',
    'How can I help you today?',
    'I am here to help you. What can I do for you?',
    'Bro just give me a break',
  ];
  return randomResponseList[Math.floor(Math.random() * randomResponseList.length)];
};

export const useTypewriter = (text: string, speed = 50) => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < text.length) {
        setDisplayText(text.substring(0, i + 1));
        i += 1;
      } else {
        clearInterval(typingInterval);
      }
    }, speed);

    return () => {
      clearInterval(typingInterval);
    };
  }, [text, speed]);

  return displayText;
};

export interface IDummyChatBotData {
  chatId: string;
  chatData: IChatBotData[];
}
export const DummyChatBotData1: IChatBotData[] = [
  {
    id: 1,
    message: 'Hello, I need help with my account.',
    sender: ChatBotSender.USER,
    timeStamp: '12:10',
  },
  {
    id: 2,
    message: 'Sure, I can assist you. What seems to be the issue?',
    sender: ChatBotSender.BOT,
    timeStamp: '12:11',
  },
];

const DummyChatBotData2: IChatBotData[] = [
  {
    id: 1,
    message: 'Can we discuss the project deadlines?',
    sender: ChatBotSender.USER,
    timeStamp: '09:00',
  },
  {
    id: 2,
    message: 'Yes, the project deadlines are as follows...',
    sender: ChatBotSender.BOT,
    timeStamp: '09:05',
  },
];

const DummyChatBotData3: IChatBotData[] = [
  {
    id: 1,
    message: 'Any updates on the sprint goals?',
    sender: ChatBotSender.USER,
    timeStamp: '14:30',
  },
  {
    id: 2,
    message: 'The sprint goals have been finalized. Let me share them with you.',
    sender: ChatBotSender.BOT,
    timeStamp: '14:35',
  },
];

export const DummyChatHistoryData: IChatHistoryData[] = [
  {
    chatDateRange: 'Today',
    chatHistory: [
      {
        chatId: 'chat_001',
        chatTitle: 'Help with account issue',
        chatTimestamp: 'Wed Feb 15 2025 16:16:08 GMT+0530 (India Standard Time)',
      },
      {
        chatId: 'chat_002',
        chatTitle: 'Project deadlines discussion',
        chatTimestamp: 'Wed Feb 11 2025 16:39:08 GMT+0530 (India Standard Time)',
      },
    ],
  },
  {
    chatDateRange: 'Last 7 Days',
    chatHistory: [
      {
        chatId: 'chat_003',
        chatTitle: 'Sprint goals review',
        chatTimestamp: 'Wed Jan 10 2025 16:16:08 GMT+0530 (India Standard Time)',
      },
    ],
  },
];

export const DummyChatData: IDummyChatBotData[] = [
  { chatId: 'chat_001', chatData: DummyChatBotData1 },
  { chatId: 'chat_002', chatData: DummyChatBotData2 },
  { chatId: 'chat_003', chatData: DummyChatBotData3 },
];
export function getRelevantChatData(chatId: string) {
  return DummyChatData.find((chat) => chat.chatId === chatId)?.chatData ?? [];
}
